import "../assets/styles/components/container-card.scss";
import ArrowRightLight from "../assets/icons/arrow-right-light";
import Study from "../assets/icons/study";
import Clock from "../assets/icons/clock";
import { NavLink } from "react-router-dom";
import { useEffect, useState } from "react";

export default function ContainerCard({ container_info, context }) {
  const [progress, setProgress] = useState(0);
  const [new_content_active, setNewContentActive] = useState(false);

  useEffect(() => {
    if (context.progress) checkProgression();
  }, [context.progress]);

  const checkProgression = () => {
    let completed = 0;
    if (container_info) {
      const new_contents = container_info.learningPills.filter((x) => x.isNew);

      let news_count_completed = 0;
      let active_pills = container_info.learningPills.map((item, index) => {
        let pill_status = context.progress.find(
          (x) => x.cmId.toString() === item.assetIdentifier
        );

        if (pill_status && pill_status?.state > 0) {
          completed++;
          if (item.isNew) news_count_completed++;
        }
        return item;
      });

      setNewContentActive(new_contents.length > news_count_completed);

      active_pills = active_pills.filter((x) => x);
      setProgress(completed / (active_pills.length / 100));
    }
  };

  if (!!container_info) {
    let total_time_count = 0;
    let total_pill_count = 0;
    container_info.learningPills.map((item) => {
      if (item.assetIdentifier) {
        total_pill_count++;

        total_time_count +=
          item.duration >= 60
            ? Math.floor(item.duration / 60)
            : item.duration > 0
            ? 1
            : 0;
      }
    });

    return (
      <NavLink
        to="/pills-list"
        state={{ ...container_info, ...{ total_time: total_time_count } }}
        className="container-card border mb-3 px-3 pt-3 pb-4 w-100 d-flex align-items-center position-relative shadow-sm"
      >
        <div className="d-flex flex-wrap w-100">
          <strong className="card-name w-100 mb-2">
            {container_info.title}
          </strong>
          <div className="card-info d-flex flex-wrap align-items-center w-100">
            {new_content_active ? (
              <span className="new-content w-100 mb-1">
                Nuove pillole disponibili
              </span>
            ) : null}
            <Study size={24} color="#20419a" />
            <span className="ms-2">{total_pill_count} pillole</span>
            {total_time_count > 0 ? (
              <>
                <Clock size={22} color="#20419a" className="ms-auto" />
                <span className="ms-2">{`${total_time_count} minut${
                  total_time_count === 1 ? "o" : "i"
                }`}</span>
              </>
            ) : null}
          </div>
        </div>
        <ArrowRightLight color="#a0a0a0" size={20} className="ms-3" />
        <progress
          className="w-100 position-absolute"
          max="100"
          value={progress}
        ></progress>
      </NavLink>
    );
  }
}
